// extracted by mini-css-extract-plugin
export default {"button":"styles_button__KymbX","primary":"styles_primary__n+D40"};